var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h6',{staticClass:"ft-ll ft-basic m-b-m"},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('span',{staticClass:"ft-red"},[_vm._v("("+_vm._s(_vm.count)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }